<template>
  <div>
    <van-row class="bg-white f-s-8 p-b-5" style="padding-left:10px" v-if="leftText != '全部' || rightText[0] != '全部'">
      <p class="f-l-l">筛选专业:</p>
      <span style="background:#F4F5F7">{{leftText}}|<span v-for="(p,i) in rightText" :key="i">{{p}}、</span></span>
    </van-row>
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <van-row style="height: 100%">
            <van-col span="8" class="searchLeft">
              <div
                v-for="(item, i) in rightList"
                :key="i"
                :class="{ leftActive: item.itid == rightActive }"
                @click="changeLeftActive(item)"
              >
                <p :class="{ leftActiveTag: item.itid == rightActive }" :style="{paddingLeft:item.itid == rightActive ? '4px' : '8px'}">
                  {{ item.itname }}
                </p>
              </div>
            </van-col>
            <van-col span="16" class="searchRight">
              <div class="allRight">
                <p class="f-s-16 m-t-05">课程专业</p>
                <van-row class="tagGroup">
                  <van-tag round type="warning" class=" m-t-3" v-for="(item, i) in leftList" @click="changeRightActive(item)"
                   :key="i" :class="[rightTagMe(i),rightAc(item)]">{{item.itname}}</van-tag>
                </van-row>
                <van-row class="m-t-05">
                  <van-col span="11">
                    <van-button
                      color="#F98D3A"
                      plain
                      block
                      round
                      style="height: 40px"
                      @click="reset"
                      >重置</van-button
                    >
                  </van-col>
                  <van-col span="11" offset="2">
                    <van-button color="#FE7B10" block round style="height: 40px" @click="goSearch"
                      >筛选</van-button
                    >
                  </van-col>
                </van-row>
              </div>
            </van-col>
          </van-row>
        </div>
        <div class="closeSearch" @click="show = false"></div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      leftList: [],
      leftActive: [],
      rightList:[],
      rightActive:"",
      leftText:'全部',
      rightText:[]
    };
  },
  created() {
    this.getLeftList()  // 获取左侧筛选列表
  },
  methods: {
    goSearch(){
      this.$emit("goSearch")
      this.show = false
    },
    reset(){
      this.leftText = '全部'
      this.rightText = ['全部']
      this.rightActive = 0
    },
    getLeftList(){
      this.ApiNew.Class.getLeftList().then(res => {
        if(res.retuCode == 5000) {
          this.rightList = res.data
          this.rightActive = res.data[0].itid
        }
      })
    },
    rightTagMe(n){
      if(n == 1 || n%3 == 1) {
        return 'm-l-03 m-r-02'
      } 
    },
    rightAc(item){
      if(item.active) {
        return 'rightTag'
      }
      return 'noAcRight'
    },
    // 更新右侧选中
    changeRightActive(item){
      if(item.itname == '全部') {
        this.leftList.forEach(p => {
          p.active = false
        })
        this.leftList[0].active = true
        this.leftActive = [0]
        this.rightText = ['全部']
        return false
      }
      if(!item.active) {
        console.log(this.rightText[0])
        if(this.rightText[0] == '全部') {
          this.leftList[0].active = false
          this.leftActive = this.leftActive.filter(pojo => {return pojo != 0})
          this.rightText = this.rightText.filter(pojo => {return pojo != '全部'})
        }
        this.rightText.push(item.itname)
        this.leftActive.push(item.itid)
      } else {
        this.leftActive = this.leftActive.filter(pojo => {return pojo != item.itid})
        this.rightText = this.rightText.filter(pojo => {return pojo != item.itname})
      }
      item.active = !item.active
    },
    // 更新左侧选中
    changeLeftActive(item) {
      this.leftText = item.itname
      this.rightActive = item.itid;
    },
    // 获取右侧列表
    getSecList() {
      let data = {
        itid :this.rightActive
      }
      this.ApiNew.Class.getSecList(data).then((res) => {
        if (res.retuCode == 5000) {
          this.leftActive = []
          this.rightText = []
          res.data.forEach(item => {
            item.active = false
          })
          res.data[0].active = true
          this.leftList = res.data
          this.rightText.push(res.data[0].itname)
          this.leftActive.push(res.data[0].itid)
        }
      });
    },
  },
  watch:{
    rightActive:{
      deep:true,
      immediate:true,
      handler(val) {
        if(val === "" ) return false
        this.getSecList()
      }
    }
  }
};
</script>


<style lang="less" scoped>
.closeSearch {
  width: 100%;
  height: 50%;
  display: block;
}
.rightTag {
  height: 30px;
  line-height: 30px;
  width: 70px;
  text-align: center;
  display: block;
  float: left;
}
.noAcRight {
  height: 30px;
  line-height: 30px;
  width: 70px;
  text-align: center;
  display: block;
  float: left;
  background: #F4F4F4;
  color: #657081;
}
.searchRight {
  height: 100%;
  .allRight {
    height: 100%;
    padding-left: 15px;
    padding-right: 15px;
    .tagGroup {
      overflow: auto;
      height: 76%;
      border-bottom: 1px solid #eaeaea;
      .van-button {
        height: 30px;
      }
    }
  }
}
.searchLeft {
  background: #f7f7f7;
  height: 100%;
  overflow: auto;
}
.searchLeft div {
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 16px;
  // height: 46px;
  p {
    padding-left: 5px;
  }
}
.leftActive {
  background: white;
}
.leftActiveTag {
  border-left: 4px solid #f08040;
}
.wrapper {
  // display: flex;
  // align-items: center;
  // justify-content: center;
  height: 100%;
}

.block {
  top: 0;
  width: 100%;
  height: 50%;
  background-color: #fff;
}
</style>